<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  beforeMount(){
    this.$api.auth.user().then(res => {
      this.$store.dispatch('userLogin', res.data.user);
    })
  },
  mounted(){

    // Recargamos la sidebar desde el container.
    
    this.$api.menu.index().then(res => {
      this.$store.dispatch('loadMenu', res.data.data)
    }).catch(err => {
      console.log('err', err);
    })
    // Cargamos la data de las ordenes. esto sirve para el modal
    //this.$store.dispatch('loadExternalOrderData');
    
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
